import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import img from '../../assets/images/599 error.svg';
import logo from '../../assets/images/undraw_signal-searching_yod3 1.svg';
import '../../assets/css/errorpage599.css';

const ErrorPage599 = () => {
    const navigate = useNavigate(); // Initialize navigate hook

    const goHome = () => {
        navigate('/dashboard'); // Navigates to the home page
    };

    return (
        <div>
            <section>
                <div className='container' style={{ marginTop: '133px' }}>
                    <div className="row" style={{marginTop:'179px'}}>
                        <div className="col-lg-6">
                            <div>
                                <img src={img} alt="Error" />
                                <span>
                                    <p style={{ marginTop: '-39px', marginLeft: '197px' }}>
                                        Network Connect Timeout Error.
                                    </p>
                                </span>

                                <div>
                                    <p style={{ fontSize: '30px', fontWeight: '600', color: '#2196F3', marginTop: '56px' }}>
                                        Hmmm...!
                                    </p>
                                    <p style={{ fontSize: '18px', fontWeight: '500', lineHeight: '32px', color: '#666666', marginTop: '20px' }}>
                                        The request exceeded the allowed response time. Please retry or check your connection.
                                    </p>
                                </div>
                                <button
                                    style={{
                                        width: '83px',
                                        height: '37px',
                                        borderRadius: '10px',
                                        color: '#2196F3',
                                        backgroundColor:'#fff',
                                        border: '1px solid #2196F3',
                                        marginLeft: '15px',
                                        marginTop: '37px'
                                    }}
                                    onClick={goHome} // Call goHome when button is clicked
                                >
                                   Retry
                                </button>
                                {/* <button
                                    style={{
                                        width: '83px',
                                        height: '37px',
                                        borderRadius: '10px',
                                        color: '#fff',
                                        backgroundColor: '#2196F3',
                                        border: 'none',
                                        marginLeft: '15px',
                                        marginTop: '37px'
                                    }}
                                    onClick={goHome} // Call goHome when button is clicked
                                >
                                    Home
                                </button> */}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src={logo} style={{ width: '72%', marginLeft: '103px' }} className='img' alt="Logo" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ErrorPage599;
